import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, CanActivate } from "@angular/router";

import { FireDataService } from './fire-data.service';

@Injectable()
export class OnlyLoggedInUsersGuardService implements CanActivate { 
  constructor(private fds: FireDataService, private router: Router, private route: ActivatedRoute) {}; 

  canActivate() {
    //console.log("OnlyLoggedInUsers");
    this.fds.user.subscribe(res => {
      if (res) {
        var a = JSON.stringify(res)
        var b = JSON.parse(a)
        var dt = Date.now()
        //console.log("User credentials expire in : ", b.stsTokenManager.expirationTime - dt);
        if (dt-300000 > b.stsTokenManager.expirationTime) {
          this.fds.afAuth.auth.currentUser.getIdToken(true)
          .then(function(idToken) {
            console.log("NEW User credentials !!!");
            return
          }).catch(function(error) {
            //if (error) throw error
            console.log("NEW User credentials ERROR...:", error);
          });
        }
      }
      if (!res) {
        this.router.navigate(["/login"]);
      }
    });
    return true
  }
}



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/only-logged-in-users-guard.service.ts